
export default {
  BASE_URL: "https://superappwatch.com",
}

